import {BillingDetails} from './billing-details';
import {PaymentParcel} from './payment-parcel';

export class Billing {
  date: string;
  promoCode: string;
  promoCodeDiscountValue: number;
  promoCodeDiscountType: number;
  discountValue: number;
  discountType: number;
  description: string;
  details: BillingDetails;
  payments: PaymentParcel[];
}



// WEBPACK FOOTER //
// ./src/app/shared/api/model/billing.ts